// extracted by mini-css-extract-plugin
export var arrowWrapper = "fn_g6";